<template>
    <x-modal
        v-if="visible"
        :wWidth="1169"
        @cancel="closeModal"
        @close="closeModal"
        @ok="sendEmail"
        :resizable="true"
        cancelText="Close"
        okText="Send Email"
        :okDisabled="(_.isEmpty(toEmails) && _.isEmpty(fromEmail)) || loading"
        :loading="loading"
        :footer="activeTab === 'send_message'">
        <div slot="title">
            Emails
        </div>

        <el-alert
            type="error"
            v-if="errors"
            :description="errors"
            show-icon/>

        <section>
            <el-tabs v-model="activeTab">
                <el-tab-pane label="Send Message" name="send_message" class="fin-space-y-4">
                    <email-send-options
                        :show-sms="true"
                        :show-email="true"
                        :is-api="isApi"/>

                    <email-recipients
                        :from-email-options="fromEmailOptions"
                        :to-email-options="toEmailOptions"
                        :bccs-email-options="bccsEmailOptions"
                        :ccs-email-options="ccsEmailOptions"
                        :is-api="isApi"/>

                    <email-templates
                        :is-api="isApi"/>
                </el-tab-pane>
            </el-tabs>
        </section>
    </x-modal>
</template>

<script>
import EmailSendOptions from "./Email/EmailSendOptions";
import EmailRecipients from "./Email/EmailRecipients";
import EmailTemplates from "./Email/EmailTemplates";
import {mapGetters} from "vuex";
import swal from "sweetalert2";

export default {
    name: 'Emails',
    components: {
        EmailRecipients,
        EmailSendOptions,
        EmailTemplates
    },
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
        isApi: {
            required: true,
        }
    },
    data() {
        return {
            activeTab: 'send_message',
            loading: false,
            errors: null,
            toEmailOptions: null,
            searchToEmailOptions: null,
            searchTimeout: 100,
            bccsEmailOptions: [],
            ccsEmailOptions: [],
        }
    },
    computed: {
        ...mapGetters({
            email: "ticketEmail/getAll",
            emailBody: "ticketEmail/getEmailBody",
            smsBody: "ticketEmail/getSmsBody",
            toEmails: "ticketEmail/getToEmails",
            fromEmail: "ticketEmail/getFromEmail",
            attachments: "ticketEmail/getAttachments",
        }),
        fromEmailOptions() {
            return [
                {
                    email: 'adobesign1@fintelligence.com.au'
                },
                {
                    email: 'adobesign2@fintelligence.com.au'
                },
                {
                    email: 'communications@fintelligence.com.au'
                },
                {
                    email: 'accreditations@fintelligence.com.au'
                },
                {
                    email: 'onboarding@fintelligence.com.au'
                },
                {
                    email: 'support@fintelligence.com.au'
                },
            ]
        }
    },
    watch: {
        'visible': {
            handler(val) {
                if (val) {
                    this.getDirectories()
                }
            },
            immediate: true,
            deep: true
        },
        'searchToEmailOptions': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.getDirectories()
                }, this.searchTimeoutWait)
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.$bus.$on('remote-fetch-toEmailOptions', (data) => {
            this.searchToEmailOptions = data
        })
    },
    beforeDestroy() {
        this.$bus.$off('remote-fetch-toEmailOptions')
    },
    methods: {
        closeModal() {
            this.loading = false
            this.errors = null
            this.$emit("update:visible", false)
            this.$bus.$emit('reload-sent-emails')
            this.$store.dispatch("ticketEmail/setFromEmail", '')
            this.$store.dispatch("ticketEmail/setToEmails", [])
            this.$store.dispatch("ticketEmail/setCCEmails", [])
            this.$store.dispatch("ticketEmail/setBCCsEmails", [])
        },
        sendEmail() {
            this.loading = true

            let formData = null

            if (_.size(this.attachments)) {
                let formData = new FormData();

                for (let i = 0; i < this.attachments.length; i++) {
                    formData.append('files[]', this.attachments[i])
                }

                formData.append('email', JSON.stringify(this.email))

                this.isApi.post('/api/email/send', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }).then(res => {
                    this.loading = false
                    this.$bus.$emit('reset-files')

                    swal({
                        type: "success",
                        title: "Success!",
                        text: "Email Sent Successfully...",
                    })

                    this.closeModal()
                }).catch((error) => {
                    this.loading = false
                    this.errors = error
                    this.$bus.$emit('reset-files')

                    swal({
                        type: "error",
                        title: "Ooops!",
                        text: "Error Sending Email \n\n" + error,
                    })

                    console.log('sendEmail error', error)
                })
            } else {
                this.isApi.post('/api/email/send', {
                    ...this.email,
                }).then(res => {
                    this.loading = false

                    swal({
                        type: "success",
                        title: "Success!",
                        text: "Email Sent Successfully...",
                    })

                    this.closeModal()
                }).catch((error) => {
                    this.loading = false
                    this.errors = error

                    swal({
                        type: "error",
                        title: "Ooops!",
                        text: "Error Sending Email \n\n" + error,
                    })

                    console.log('sendEmail error', error)
                })
            }
        },
        getDirectories() {
            this.$admin.get('/api/lender_tenant_directories/get-directories', {
                params: {
                    search: this.searchToEmailOptions
                }
            }).then(res => {
                this.toEmailOptions = res.data
                this.bccsEmailOptions = res.data
                this.ccsEmailOptions = res.data
            })
        }
    }
}
</script>
